module.exports = {
    "source_code": "HLXEMS",
    "name": "Mercer University School of Law",
    "site_id": "info.law.mercer.edu",
    "title": "Mercer University",
    "tfn": "",
    "url": "https://info.law.mercer.edu",
    "gtm_code": "GTM-NMLQ2X",
}